import { useQuery } from "@tanstack/react-query";
import * as api from "@/lib/api";

export function useArticles(
  filters: { limit?: number; category?: string; topic?: string; writerId?: string; subscriberAddress?: string; sort?: string } = {},
) {
  return useQuery({
    queryKey: ["articles", filters],
    queryFn: () => api.listArticles(filters),
  });
}

export function useArticle(id: string) {
  return useQuery({
    queryKey: ["article", id],
    queryFn: () => api.getArticle(id),
    enabled: !!id,
  });
}

export function useWriterProfile(writerId: string) {
  return useQuery({
    queryKey: ["writerProfile", writerId],
    queryFn: () => api.getWriterProfile(writerId),
    enabled: !!writerId,
  });
}

export function useTopicSearch(query: string) {
  return useQuery({
    queryKey: ["topicSearch", query],
    queryFn: () => api.searchTopics(query),
    enabled: query.length >= 1,
  });
}
